var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo, useCallback, useEffect } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import isEqual from 'lodash-es/isEqual';
import RegistrationComponent from '@/shared/components/registration/RegistrationComponent';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { createEmptyTimerRegistration, executeAction, isRegistrationValid, getCurrentTime, } from '@/shared/components/registration/registrationHelpers';
import handleHttpError from '@/shared/services/HandleHttpError';
var messages = defineMessages({
    Relation: {
        id: 'Relation',
        defaultMessage: 'Relation',
    },
    CreateTimerRegistration: {
        id: 'CreateTimerRegistration',
        defaultMessage: 'Create timer registration',
    },
});
var registrationOptions = {
    showDate: false,
    showFromUntil: false,
    showDuration: false,
    showQuantity: false,
    showPrice: false,
    showDiscount: false,
    showVat: false,
    showTotalAmount: false,
    showBillable: true,
    showInForfait: true,
    showInternalRemark: true,
    showInvoiceRemark: true,
    showInteraction: false,
};
var CreateTimerRegistrationModal = function (_a) {
    var _b = _a.initialValue, initialValue = _b === void 0 ? {} : _b, onSave = _a.onSave, onClose = _a.onClose, _c = _a.show, show = _c === void 0 ? false : _c;
    var _d = useState(createEmptyTimerRegistration(initialValue)), registration = _d[0], setRegistration = _d[1];
    var _e = useState(false), validationVisible = _e[0], showValidation = _e[1];
    var _f = useState(false), saving = _f[0], setSaving = _f[1];
    var _g = useState(false), priceLoading = _g[0], setPriceLoading = _g[1];
    var intl = useIntl();
    var save = useCallback(function () {
        setSaving(true);
        var resource = registration.resource, invoiceStreamId = registration.invoiceStreamId, fromMinutes = registration.fromMinutes, plannedTaskId = registration.plannedTaskId, plannedTaskTemplateId = registration.plannedTaskTemplateId, plannedTaskName = registration.plannedTaskName, mainPlannedTaskId = registration.mainPlannedTaskId, mainTaskTemplateId = registration.mainTaskTemplateId, mainPlannedTaskName = registration.mainPlannedTaskName, referenceYear = registration.referenceYear, remark = registration.remark, internalRemark = registration.internalRemark, inForfait = registration.inForfait, isBillable = registration.isBillable;
        var value = {
            resourceId: resource.id,
            invoiceStreamId: invoiceStreamId,
            fromMinutes: fromMinutes || getCurrentTime(),
            plannedTaskId: plannedTaskId,
            plannedTaskTemplateId: plannedTaskTemplateId,
            plannedTaskName: plannedTaskName,
            mainPlannedTaskId: mainPlannedTaskId,
            mainTaskTemplateId: mainTaskTemplateId,
            mainPlannedTaskName: mainPlannedTaskName,
            referenceYear: referenceYear,
            remark: remark,
            internalRemark: internalRemark,
            inForfait: inForfait,
            isBillable: isBillable,
        };
        Promise.resolve(onSave(value))
            .then(function () {
            setSaving(false);
        }, handleHttpError(intl))
            .finally(function () {
            setSaving(false);
        });
    }, [onSave, registration, intl]);
    var doRegistrationAction = useCallback(function (action, value) {
        var newValue = executeAction(registration, action, value);
        if (isEqual(newValue, registration))
            return;
        setRegistration(newValue);
    }, [registration]);
    var isValid = useMemo(function () { return isRegistrationValid(registration, registrationOptions); }, [
        registration,
    ]);
    useEffect(function () {
        if (show) {
            showValidation(false);
            setRegistration(createEmptyTimerRegistration(initialValue));
        }
        else {
            setRegistration(null);
        }
    }, [show, initialValue]);
    return (_jsx(OkCancelModal, __assign({ title: _jsx("span", { children: _jsx(FormattedMessage, __assign({}, messages.CreateTimerRegistration)) }), show: show, onClose: onClose, onSave: save, disabled: saving || priceLoading || (validationVisible && !isValid), onHoverSave: function () { return showValidation(true); } }, { children: _jsx("div", __assign({ className: "form-horizontal" }, { children: registration ? (_jsx(RegistrationComponent, { registration: registration, onAction: doRegistrationAction, onPriceLoadingChanged: setPriceLoading, options: registrationOptions, showValidation: validationVisible })) : null })) })));
};
export default CreateTimerRegistrationModal;
